<template>
  <div class="recharge_left capital_first">
    <el-card class="box-card" shadow="never">
      <div  class="clearfix" style="position:relative;">
        <p style="font-size: 20px; font-weight: bold; margin-top: 5px;">{{$t('account.fundingAccount')}}</p>
        <el-button type="primary" style="float: right;background-color: var(--baseColor);border-color:var(--baseColor); color: #fff; margin-top: -30px;" @click="goApply">{{ $t('strategyNow.newAccount') }}</el-button>
      </div>
    </el-card>
    <!-- To show user's ongoing capital overall record -->
    <el-card class="box-card1" shadow="never">
      <div class="capitalInfo">
        <el-row :gutter="10">
          <el-col :span="8">
            <div class="capitaldetail capitaldetail1 content-flex">
              <h4>
                {{ $t('capitalAccountDetails.curentTotalAsset') }}  
              </h4>
              <p class="balance">
                {{ currentTotalAssetSum}}<span style="font-size: 20px">{{ $t('friendCoupon.yuan') }}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="capitaldetail capitaldetail2 content-flex">
              <h4>
                {{ $t('capitalAccountDetails.currentTotalBond') }}  
              </h4>
              <p class="balance">
                {{ currentBondSum }}<span style="font-size: 20px">{{ $t('friendCoupon.yuan') }}</span>
              </p>
            </div>
            </el-col>
          <el-col :span="8">
            <div class="capitaldetail capitaldetail3 content-flex">
              <h4>
                {{ $t('capitalAccountDetails.currentTotalProfitLoss') }}
                
              </h4>
              <p class="balance">
                {{ currentProfitLossSum}}<span style="font-size: 20px">{{ $t('friendCoupon.yuan') }}</span>
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <el-card class="box-card" shadow="never">
      <!-- when clicking funding tab always navigate to all capitals-->
      <el-tabs v-model="activeName" id="stratergyNowtabs" @tab-click="handleTabClick">
        <el-tab-pane name="1" :label="$t('strategyNow.funding')">
          <el-button type="primary" class="mainButtons" :class="{ activeButton: activeButtonType === 'all' }" @click="changeList('all')">{{ $t('strategyNow.all') }}</el-button>
          <el-button type="primary" class="mainButtons" :class="{ activeButton: activeButtonType === 'day' }" @click="changeList('day')">{{ $t('strategyNow.byDay') }}</el-button>
          <el-button type="primary" class="mainButtons" :class="{ activeButton: activeButtonType === 'week' }" @click="changeList('week')">{{ $t('strategyNow.byWeek') }}</el-button>
          <el-button type="primary" class="mainButtons" :class="{ activeButton: activeButtonType === 'month' }" @click="changeList('month')">{{ $t('strategyNow.byMonth') }}</el-button>
          <el-button type="primary" class="mainButtons" :class="{ activeButton: activeButtonType === 'free' }" @click="changeList('free')">{{$t('capitalAccount.interestFree')}}</el-button>
          <el-button type="primary" class="mainButtons" :class="{ activeButton: activeButtonType === 'vip' }" @click="changeList('vip')">{{$t('capitalAccount.vip')}}</el-button>
          <div v-if="currentList.length === 0" class="sell_top">
              <span class="center-content">{{ $t('strategyNow.noMoreData') }}</span>
          </div>
          <div v-else class="sell_top" v-for="(item,index) in currentList" :key="index">
            <p class="entrust_p1">
              {{item.name}}
              <span style="margin-left: 10px;">{{item.order}}</span>
              <span style="margin-left: 10px;">{{item.time}}</span>
            </p>
            <br>
            <p class="entrust_p2">
              {{$t('capitalAccountDetails.managementFee')}}:{{item.manage}}{{$t('friendCoupon.yuan')}}
              <!--              /{{text}}-->
              <!--              <span>已策略天数：{{day}}个{{text}}</span>-->
            </p>
            <ul class="entrust_ul" style="margin-top: -5px;">
              <li class="ntrust_ul_active">
                <router-link v-if="(item.direction_capital === undefined || item.direction_capital === 0 || item.direction_capital === 2)" :to="{name:'Stockdetailed',query:{cid:item.cid,symbol:'sh000001',direction:0}}">{{$t('capitalAccountDetails.longTrading')}}</router-link>
          
                <router-link v-if="item.direction_capital==2||item.direction_capital==1" :to="{name:'Stockdetailed',query:{cid:item.cid,symbol:'sh000001',direction:1}}">{{$t('capitalAccountDetails.shortTrading')}}</router-link>
              </li>
<!--              <li @click="showProfit(item.cid)">提取利润</li>-->
              <li @click="showAdd(item.cid)">{{$t('capitalAccountDetails.additionalAllocation')}}</li>
              <li @click="showBondAdd(item.cid)">{{$t('capitalAccountDetails.marginCall')}}</li>
              <li @click="getCapitalData(item.cid,'all')">{{$t('timeBaoDetails.title')}}</li>
              <li @click="showSettlement(item.cid)" style="margin-right: 30px;">{{$t('capitalAccountDetails.applySettlement')}}</li>
            </ul>
            <p class="entrust_p3"></p>
            <div class="entrust_center clearfix">
              <div class="entrust_centerLeft">
                <h4>{{$t('strategyNow.TotAssets')}}</h4>
                <p class="entrust_p4">{{item.total}}</p>
                <p class="entrust_p5">
                  {{ $t('strategyNow.profitAndLoss') }}
                  <span>{{( Number(item.divided)*100) }}%{{ $t('strategyNow.profitDistribution') }}</span>
                </p>
                <p class="entrust_p6" :class="item.profit_loss >= 0 ? 'red' : 'green' ">
                  {{item.profit_loss}}
                  <span>{{item.proportion}}%</span>
                </p>
              </div>
              <div class="entrust_centerRight">
                <p class="entrust_p7">
                  <span>{{$t('positionInquiry.positionMarketValue')}}<a href="javascript:void(0);" class="red font12" @click="getHoldData(item.cid)">{{ $t('strategyNow.details') }}</a></span>
                  <span>{{$t('capitalAccountDetails.positionRatio')}}</span>
                  <span>{{$t('capitalHistory.availableBalance')}}<a href="javascript:void(0);" class="red font12" @click="getCapitalData(item.cid,'all')">{{ $t('strategyNow.details') }}</a></span>
                </p>
                <p class="entrust_p7" style="margin: 30px 0 43px 0;font-weight: 600;">
                  <span>{{Number(item.market).toFixed(2)}}</span>
                  <span>{{item.depot_ratio}}</span>
                  <span>{{item.use}}</span>
                </p>
                <p class="entrust_p7" style="margin-bottom: 30px;">
                  <span>{{$t('capitalAccountDetails.totalFunds')}}<a href="javascript:void(0);" class="red font12" @click="getCapitalData(item.cid,'money')">{{ $t('strategyNow.details') }}</a></span>
                  <span>{{$t('capitalAccountDetails.totalFunds')}}</span>
                  <span>{{$t('capitalAccountDetails.riskMargin')}}<a href="javascript:void(0);" class="red font12"
                                @click="getCapitalData(item.cid,'ensure')">{{ $t('strategyNow.details') }}</a></span>
                </p>
                <p class="entrust_p7" style="font-weight: 600;margin-bottom: 50px;">
                  <span>{{item.total_capital}}</span>
                  <span>{{item.number}}</span>
                  <span>{{item.bond}}</span>
                </p>
              </div>
            </div>
            <p class="entrust_p8">
              <!-- 当前仓位：
              <span>0.00%</span>-->
            </p>
            <p class="entrust_p9">
              <span></span>
              <span></span>
              <span></span>
            </p>
            <p class="entrust_p10">
              <span>{{$t('capitalHistory.lossClosingLine')}} ：{{item.close}}{{$t('friendCoupon.yuan')}} ({{ item.close_line_ratio }})</span>
              <span>{{ $t('capitalHistory.lossRatio') }} ：{{item.warning}}{{$t('friendCoupon.yuan')}} ({{ item.warning_line_ratio }})</span>
            </p>
          </div>
        </el-tab-pane>
        <el-tab-pane name="2" :label="$t('strategyNow.completed')">
          <!--   <el-button type="primary" @click="changeList('all')">全部</el-button>
             <el-button type="primary" @click="changeList('day')">按天</el-button>
             <el-button type="primary" @click="changeList('week')">按周</el-button>
             <el-button type="primary" @click="changeList('month')">按月</el-button>
             <el-button type="primary" @click="changeList('free')">免息</el-button>-->
          <div v-if="historyList.length === 0" >
            <span class="center-content">{{ $t('strategyNow.noMoreData') }}</span>
          </div>
          <ul v-else class="sell_ul1">
            <li  v-for="(item,index) in historyList" :key="index" @click="goDetails(item.cid)">
              <p class="sell_p8"></p>
              <div>
                <div class="sell_title">
                  
                  <p>{{item.name}}({{item.order}})</p>
                  <span></span>
                  <small>{{item.time}}</small>
                     
                    
                  
                 
                      
                </div>
                <div
                        style="
                          display: flex;
                          justify-content: flex-end;
                          align-items: center;
                          margin-top: -40px;
                          margin-right: 10px;
                        "
                      >
                        <div class="sideGrey-btn">{{ $t('stockrise.settled') }}</div>
                      </div>

                <p class="sell_p9">
                  <div style="margin: 10px 0px 30px 40px">
                  <el-row>
                    <el-col :span="5">
                      <div class="value-descrip">{{ $t('capitalAccountDetails.applicationQuota') }}:</div>
                      <div class="value">
                        {{ item.total }}
                      </div>
                    </el-col>
                    <el-col :span="5">
                      <div class="value-descrip"> {{$t('strategyNow.proAndLoss')}}:</div>
                      <div class="value" style="color: #ed0003">
                        {{ item.profit }}({{ item.proportion }}%)
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="value-descrip">{{$t('strategyNow.triggerAlert')}}:</div>
                      <div class="value">
                        {{ item.warning }}
                      </div>
                    </el-col>
                    <el-col :span="5">
                      <div class="value-descrip">{{$t('strategyNow.stopLoss')}}:</div>
                      <div class="value" style="color: #ed0003">
                        {{ item.close }}
                      </div>
                    </el-col>
                    <el-col :span="5">
                      <div class="value-descrip">{{$t('strategyNow.freezeFunds')}}:</div>
                      <div class="value" style="color: #304479">
                        {{ item.bond }}
                      </div>
                    </el-col>
                  </el-row>
                </div>
                </p>
              </div>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <!-- 弹窗-利润提取 -->
    <div class="show2Box moduleBox">
      <div class="show2">
        <div class="show2_title">
          <div>{{$t('strategyNow.profitWithdrawal')}}</div>
          <div @click="hiddenProfit()">x</div>
        </div>
        <div class="show2_content">
          <div>{{$t('strategyNow.strategyAccBalance')}}：{{available}}{{$t('friendCoupon.yuan')}}</div>
          <div>{{$t('strategyNow.currentProfit')}}：{{extractProfit}}{{$t('friendCoupon.yuan')}}</div>
          <div>
            <img src="../assets/img/sell_get.png">
            <input v-model="extractMoney" type="number" :placeholder="$t('strategyNow.enterWithdrawalAmount')">
          </div>
          <div>{{$t('strategyNow.maxProfitWithdrawn')}}{{extractMax}}{{$t('friendCoupon.yuan')}}</div>
        </div>
        <div class="show2_foot">
          <button @click="operationProfit()">{{$t('capitalAccountDetails.confirm')}}</button>
        </div>
      </div>
    </div>
    <!-- 弹窗 追加策略 -->
    <div class="show3Box moduleBox">
      <div class="show3">
        <div class="show2_title">
          <div>{{$t('capitalAccountDetails.additionalAllocation')}}</div>
          <div @click="hiddenAdd()">x</div>
        </div>
        <div class="show2_content">
          <p class="show_content_strategynow_colored">
          <span>{{ $t('increaseInfo.totAccountBal') }} {{cashCapitalInfo}}{{$t('friendCoupon.yuan')}}</span><br>  
          <span>{{ $t('increaseInfo.currentSubBal') }} {{balance}}{{$t('friendCoupon.yuan')}} </span><br>
          <span>{{ $t('increaseInfo.currentLossWarnLine') }} {{warningIncreaseInfo}}{{$t('friendCoupon.yuan')}} <span class="percentageColor">（-{{warning_line_ratio_increase_info}}）</span></span><br>
          <span>{{ $t('increaseInfo.currentLossCloseLine') }} {{closeIncreaseInfo}}{{$t('friendCoupon.yuan')}} <span class="percentageColor">（-{{close_line_ratio_increase_info}}）</span></span>
          </p>
          <div class="strategynow_matching_amt">
            <img src="../assets/img/sell_get.png">
            <input oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px;" type="digit" v-model="addMoney" :placeholder="$t('increaseInfo.enterAdditionalAmount')">
          </div>
          <p class="show_content_strategynow">
            <span>{{ $t('increaseInfo.totAccountBalAddition') }} {{afterCashCapitalInfo}}{{$t('friendCoupon.yuan')}}</span><br>
            <span>{{$t('increaseInfo.subAccountBalAddition')}} {{balanceAfter}}{{$t('friendCoupon.yuan')}} </span><br>
            <span>{{$t('increaseInfo.lossWarnLineAddition')}} {{warningIncreaseInfoAfter}}{{$t('friendCoupon.yuan')}} <span class="percentageColor">（-{{warning_line_ratio_increase_info_after}}%）</span></span><br>
            <span>{{$t('increaseInfo.lossCloseLineAddition')}} {{closeIncreaseInfoAfter}}{{$t('friendCoupon.yuan')}} <span class="percentageColor">（-{{close_line_ratio_increase_info_after}}%）</span></span>
          </p>
        </div>
        <div class="show2_foot">
          <button @click="operationAdd()">{{$t('capitalAccountDetails.confirm')}}</button>
        </div>
      </div>
    </div>
    <!-- 弹窗 追加履约金 -->
    <div class="show4Box moduleBox">
      <div class="show4">
        <div class="show2_title">
          <div>{{$t('capitalAccountDetails.marginCall')}}</div>
          <div @click="hiddenBondAdd()">x</div>
        </div>
        <div class="show2_content">
          <p class="show_content_strategynow_colored">
            <span>{{ $t('increaseInfo.totAccountBal') }} {{cashBondInfo}}{{$t('friendCoupon.yuan')}}</span><br>
            <span>{{ $t('increaseInfo.currentSubBal') }} {{balance}}{{$t('friendCoupon.yuan')}}</span><br>
            <span>{{ $t('increaseInfo.currentLossWarnLine') }} {{warningIncreaseBondInfo}}{{$t('friendCoupon.yuan')}} <span class="percentageColor">（-{{warning_line_ratio_increase_bond_info}}）</span></span><br>
            <span>{{ $t('increaseInfo.currentLossCloseLine') }} {{closeIncreaseBondInfo}}{{$t('friendCoupon.yuan')}} <span class="percentageColor">（-{{close_line_ratio_increase_bond_info}}）</span></span>
          </p>
          <div class="strategynow_matching_amt">
            <img src="../assets/img/sell_get.png">
            <input oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px;" type="digit" v-model="addBondMoney" :placeholder="$t('increaseInfo.enterAdditionalAmount')">
          </div>
          <p class="show_content_strategynow">
            <span>{{ $t('increaseInfo.totAccountBalAddition') }} {{afterCashBondInfo}}{{$t('friendCoupon.yuan')}} </span><br>
            <span>{{$t('increaseInfo.subAccountBalAddition')}} {{balanceAfter}}{{$t('friendCoupon.yuan')}} </span><br>
            <span>{{$t('increaseInfo.lossWarnLineAddition')}} {{warningIncreaseBondInfo}}{{$t('friendCoupon.yuan')}} <span class="percentageColor">（-{{warning_line_ratio_increase_bond_info_after}}%）</span></span><br>
            <span>{{$t('increaseInfo.lossCloseLineAddition')}} {{closeIncreaseBondInfo}}{{$t('friendCoupon.yuan')}} <span class="percentageColor">（-{{close_line_ratio_increase_bond_info_after}}%）</span></span>
          </p>
        </div>
        <div class="show2_foot">
          <button @click="operationBondAdd()">{{$t('capitalAccountDetails.confirm')}}</button>
        </div>
      </div>
    </div>
    <!-- 弹窗 申请结算 -->
    <div class="show1Box moduleBox">
      <div class="show1">
        <div class="show1_title">
          <div>{{$t('strategyNow.confirmSettlement')}}</div>
          <div @click="hiddenSettlement()">x</div>
        </div>
        <div class="show1_content">
          <div>{{ $t('strategyNow.confirmSettlementQ') }}</div>
        </div>
        <div class="show1_foot">
          <button @click="operationSettlement()">{{$t('capitalAccountDetails.confirm')}}</button>
        </div>
      </div>
    </div>

    <el-dialog :title="$t('strategyNow.statement')" :visible.sync="capitalState">
      <el-table
        height="500px"
        size="small"
        border
        :data="capitalData"
        stripe
        style="width: 100%">
        <el-table-column
          type="index"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column
          prop="create_time"
          :label="$t('strategyNow.time')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          :label="$t('entrustInquiry.stock')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('strategyNow.type')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="number"
          :label="$t('friendCoupon.amount')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="balance"
          :label="$t('strategyNow.balance')"
          align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="capitalState = false">{{$t('rechargeau.sure')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('trading.position')" :visible.sync="holdState">
      <el-table
        height="560px"
        size="small"
        :data="holdData"
        border
        stripe
        style="width: 100%">
        <el-table-column
          type="index"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column
          prop="name"
          :label="$t('entrustInquiry.stock')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="market"
          :label="$t('strategyNow.marketValue')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="number"
          :label="$t('trading.position')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="sellable"
          :label="$t('strategyNow.available')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="newPrice"
          :label="$t('strategyNow.currentPrice')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="price"
          :label="$t('strategyNow.cost')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="profitPrice"
          :label="$t('strategyNow.profitAndLossWithoutMeas')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="priceRatio"
          :label="$t('strategyNow.profitAndLossMargin')"
          align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.priceRatio }}%</p>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="holdState = false">{{$t('rechargeau.sure')}}</el-button>
      </span>
    </el-dialog>


    <el-dialog :title="$t('strategyNow.funds')" :visible.sync="moneyState">
      <el-table
        height="500px"
        size="small"
        border
        :data="moneyData"
        stripe
        style="width: 100%">
        <el-table-column
          type="index"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column
          prop="time"
          :label="$t('strategyNow.time')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('strategyNow.type')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="number"
          :label="$t('friendCoupon.amount')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="balance"
          :label="$t('strategyNow.balance')"
          align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="moneyState = false">{{$t('rechargeau.sure')}}</el-button>
      </span>
    </el-dialog>
  </div>


  <!--<div class="recharge_left capital_first">
    <p class="capital_p1">
      <span>当前策略</span>
    </p>
    <div class="sell_top" v-for="(item,index) in list" :key="index">
      <div class="sell_title">
        <p>{{item.name}}({{item.order}})</p>
        <span>提示：当账户触发预警时，系统将自动按照合约履约金10%补保</span>
        <small>{{item.time}}</small>
      </div>
      <div class="sell_content clearfix">
        <div class="sell_contentLeft">
          <img src="../assets/img/account_88.png" alt>
          <p class="sell_p1">
            <span>触发止损</span>
            <small style="color: #e53349;">{{item.close}}</small>
          </p>
          <p class="sell_p2">
            <span>触发预警</span>
            <small style="color: #ffd539;">{{item.warning}}</small>
          </p>
          &lt;!&ndash; <p class="sell_p3">
            <span>触发止盈</span>
            <small style="color: #68c90a;">8800.00</small>
          </p>&ndash;&gt;
          <p class="sell_p4">
            <span>当前额度</span>
            <small>{{item.use}}</small>
          </p>
          <p class="sell_p5">
            <span>冻结资金</span>
            <small>{{item.frozen}}</small>
          </p>
          &lt;!&ndash; <div id="myChart" style="width: 499px;height:255px;"></div> &ndash;&gt;
        </div>
        <div class="sell_contentRight">
          <p class="sell_p6" style="margin-top: 33px;">
            <span>
              申请额度：
              <small style="color: #121816;">{{item.total}}</small>
            </span>
            <span>
              触发警戒：
              <small style="color: #f06f11;">{{item.warning}}</small>
            </span>
          </p>
          <p class="sell_p6">
            <span>
              触发止损：
              <small style="color: #ed0003;">{{item.close}}</small>
            </span>
            <span>
              浮动盈亏：
              <small style="color: #ed0003;">{{item.profit_loss}}({{item.proportion}}%)</small>
            </span>
          </p>
          <p class="sell_p6">
            <span>
              冻结资金：
              <small style="color: #304479;">{{item.frozen}}</small>
            </span>
            <span>
              <small></small>
            </span>
          </p>
          <p class="sell_p7"></p>
          <a class="sell_btn" @click="goDeal(item)">去交易</a>
        </div>
      </div>
    </div>
  </div>-->
</template>
<script>
  import $ from "jquery";
  import eventBus from "../assets/js/eventBus";

  // import echarts from "echarts";

  export default {
    name: "Strategynow",
    data() {
      return {
        cashCapitalInfo:"0.00",
        afterCashCapitalInfo:"",
        cashBondInfo:"0.00",
        afterCashBondInfo:"",
        increase_bond_capital:"",
        increase_bond:"",
        warning_ratio:"0.00",
        close_ratio:"0.00",
        multiple:0,
        number:0,
        balanceAfter:"0.00",
        warning_line_ratio_increase_info:"0.00",
        close_line_ratio_increase_info:"0.00",
        warningIncreaseInfo: "0.00",
        closeIncreaseInfo: "0.00",
        warning_line_ratio_increase_info_after:"0.00",
        close_line_ratio_increase_info_after:"0.00",
        warningIncreaseInfoAfter: "0.00",
        closeIncreaseInfoAfter: "0.00",
        warning_line_ratio_increase_bond_info:"0.00",
        close_line_ratio_increase_bond_info:"0.00",
        warningIncreaseBondInfo: "0.00",
        closeIncreaseBondInfo: "0.00",
        warning_line_ratio_increase_bond_info_after:"0.00",
        close_line_ratio_increase_bond_info_after:"0.00",
        activeName: '1',
        cid: '',
        //全部子账户
        currentAllList: [],
        currentList: [],
        historyList: [],
        name: "",
        order: "",
        type: "", //策略类型  1天配 2月配
        time: "",
        total: "0.00",
        market: "0.00",
        depot_ratio: "",
        available: "0.00",
        profit_loss: "0.00",
        ratio: "0.00",
        warning: "0.00",
        close: "0.00",
        capital_total: "0.00",
        apply_quota: "0.00",
        bond: "0.00",
        divided: "0.00",
        manage: "0.00",
        day: "0.00",
        text: "交易日", //交易日 或者交易月
        extractProfit: "0.00", //利润提取 盈亏
        extractMax: "0.00", //最大提取金额
        extractMoney: "", //提取输入金额
        balance: "0.00", //余额
        minAdd: "0.00", //最低追加策略金额
        addMoney: "", //追加策略金额
        minBondAdd: "", //最低追保证金金额
        addBondMoney: "", //追加保证金 金额
        //对账单状态
        capitalState: false,
        //对账单数据
        capitalData: [],
        //持仓状态
        holdState:false,
        //持仓数据
        holdData:[],
        //资金状态
        moneyState:false,
        //资金数据
        moneyData:[],
        currentBondSum:"0.00",
        currentProfitLossSum:"0.00",
        currentTotalAssetSum:"0.00",
        activeButtonType: 'all', // Default selected button
      };

    },
    mounted: function () {
      this.getNowData();
      this.getHistoryData();
    },
    watch:{
      addMoney: function (value){
        if(value){
            //capital account balance after add values - increase capital
            let after_total = parseFloat(this.balance) + (parseFloat(this.multiple)*(parseFloat(value))) + parseFloat(value);
            this.balanceAfter = parseFloat(after_total).toFixed(2);

            //main after add values - increase capital
            let cash = (parseFloat(this.cashCapitalInfo) - parseFloat(value));
            this.afterCashCapitalInfo = parseFloat(cash).toFixed(2);

            //warning ratio after add values - increase capital
            let afterWarningRatio = (((parseFloat(this.bond)+parseFloat(this.increase_bond_capital)+parseFloat(value))-((parseFloat(this.bond)+parseFloat(value))*parseFloat(this.warning_ratio)))/(parseFloat(this.bond)+parseFloat(this.increase_bond_capital)+parseFloat(value)))*100;
            this.warning_line_ratio_increase_info_after = parseFloat(afterWarningRatio).toFixed(2);

            //closing ratio after add values - increase capital
            let afterClosingRatio = (((parseFloat(this.bond)+parseFloat(this.increase_bond_capital)+parseFloat(value))-((parseFloat(this.bond)+parseFloat(value))*parseFloat(this.close_ratio)))/(parseFloat(this.bond)+parseFloat(this.increase_bond_capital)+parseFloat(value)))*100;
            this.close_line_ratio_increase_info_after = parseFloat(afterClosingRatio).toFixed(2);

            //warning value after add values - increase capital
            let afterWarningData = (parseFloat(this.warning_ratio) * (parseFloat(this.bond) + parseFloat(value))) + (parseFloat(this.multiple) * parseFloat(value)) + parseFloat(this.number);
            this.warningIncreaseInfoAfter = parseFloat(afterWarningData).toFixed(2);

            //closing value after add values - increase capital
            let afterClosingData = (parseFloat(this.close_ratio) * (parseFloat(this.bond) + parseFloat(value))) + (parseFloat(this.multiple) * parseFloat(value)) + parseFloat(this.number);
            this.closeIncreaseInfoAfter = parseFloat(afterClosingData).toFixed(2);
        }else{
            this.afterCashCapitalInfo = parseFloat(this.cashCapitalInfo).toFixed(2);
            this.balanceAfter = this.balance;
            this.warningIncreaseInfoAfter = this.warningIncreaseInfo;
            this.closeIncreaseInfoAfter = this.closeIncreaseInfo;
            this.warning_line_ratio_increase_info_after = this.warning_line_ratio_increase_info.replace(/[^0-9.-]/g, '');
            this.close_line_ratio_increase_info_after = this.close_line_ratio_increase_info.replace(/[^0-9.-]/g, '');
        }
      },
      addBondMoney: function (value){
        if(value){
            //capital account balance after add values - increase bond
            let after_total = (parseFloat(value) + parseFloat(this.balance));
            this.balanceAfter = parseFloat(after_total).toFixed(2);

            //main after add values - increase bond
            let cash = (parseFloat(this.cashBondInfo) - parseFloat(value));
            this.afterCashBondInfo = parseFloat(cash).toFixed(2);

            //warning ratio after add values - increase bond
            let afterWarningRatio = (((parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value))-(parseFloat(this.bond)*parseFloat(this.warning_ratio)))/(parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value)))*100;
            //let afterWarningRatio = (((parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value))-(parseFloat(this.bond)*parseFloat(this.warning_ratio)))/parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value))*100;
            this.warning_line_ratio_increase_bond_info_after = parseFloat(afterWarningRatio).toFixed(2);

            //closing ratio after add values - increase bond
            let afterClosingRatio = (((parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value))-(parseFloat(this.bond)*parseFloat(this.close_ratio)))/(parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value)))*100;
            //let afterClosingRatio = (((parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value))-(parseFloat(this.bond)*parseFloat(this.close_ratio)))/parseFloat(this.bond)+parseFloat(this.increase_bond)+parseFloat(value))*100;
            this.close_line_ratio_increase_bond_info_after = parseFloat(afterClosingRatio).toFixed(2);
        }else{
            this.afterCashBondInfo = parseFloat(this.cashBondInfo).toFixed(2);
            this.balanceAfter = this.balance;
            this.warning_line_ratio_increase_bond_info_after = this.warning_line_ratio_increase_bond_info.replace(/[^0-9.-]/g, '');
            this.close_line_ratio_increase_bond_info_after = this.close_line_ratio_increase_bond_info.replace(/[^0-9.-]/g, '');
        }
      }
  },
    methods: {
      getNowData() {
        let that = this;
        that
          .$http({
            url: "/app/Capital/current_operate",
            method: "post",
            data: {
              
            },
            transformRequest: [(data) => JSON.stringify(data)]
          })
          .then(function (res) {
            if (res.data.status == 200) {
              that.currentAllList = res.data.data;
              that.currentList = res.data.data;

              that.getOngoingCapitalData();
            } else {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      },
      //To show ongoing record data
      getOngoingCapitalData() {
        let currentBondSum = 0.00;
        let currentProfitLossSum = 0.00;
        let currentTotalAssetSum = 0.00;
        for (let i = 0; i < this.currentAllList.length; i++) {
          currentBondSum += parseFloat(this.currentAllList[i].bond || 0);
          currentProfitLossSum += parseFloat(this.currentAllList[i].profit_loss || 0);
        };
        this.currentBondSum = currentBondSum.toFixed(2); 
        this.currentProfitLossSum = currentProfitLossSum.toFixed(2);
        this.currentTotalAssetSum = (currentBondSum + currentProfitLossSum).toFixed(2); 
      },

      changeList(type) {
        let that = this;
        this.activeButtonType = type; // Set the active button type
        let temp = [];
        switch (type) {
          case 'all':
            that.currentList = that.currentAllList;
            break;
          case 'day':
            for (let i = 0, len = that.currentAllList.length; i < len; i++) {
              if (that.currentAllList[i].capital_type === 1) {
                temp.push(that.currentAllList[i]);
              }
            }
            that.currentList = temp;
            break;
          case 'week':
            for (let i = 0, len = that.currentAllList.length; i < len; i++) {
              if (that.currentAllList[i].capital_type === 3) {
                temp.push(that.currentAllList[i]);
              }
            }
            that.currentList = temp;
            break;
          case 'month':
            for (let i = 0, len = that.currentAllList.length; i < len; i++) {
              if (that.currentAllList[i].capital_type === 2) {
                temp.push(that.currentAllList[i]);
              }
            }
            that.currentList = temp;
            break;
          case 'free':
            for (let i = 0, len = that.currentAllList.length; i < len; i++) {
              if (that.currentAllList[i].capital_type === 4 || that.currentAllList[i].capital_type === 5 || that.currentAllList[i].capital_type === 6) {
                temp.push(that.currentAllList[i]);
              }
            }
            that.currentList = temp;
            break;
          case 'vip':
            for (let i = 0, len = that.currentAllList.length; i < len; i++) {
              if (that.currentAllList[i].capital_type === 7) {
                temp.push(that.currentAllList[i]);
              }
            }
            that.currentList = temp;
            break;
        }
      },
      handleTabClick(tab) {
      if (tab.name === "1") {
        // Check if the funding tab is active
        this.changeList("all"); // Load all data
      }
    },
      //利润提取 - 显示
      showProfit(cid) {
        let that = this;
        that.cid = cid;
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "profit_out",
            token: sessionStorage.getItem("token"),
            cid: cid
          },
            transformRequest: [(data) => JSON.stringify(data)]
        })
          .then(function (res) {
            if (res.data.status == 200) {
              that.extractProfit = res.data.data.profit;
              that.extractMax = res.data.data.max;
              $(".show2Box").fadeIn(50);
            } else {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      },
      //利润提取 - 隐藏
      hiddenProfit() {
        $(".show2Box").fadeOut(50);
      },
      //利润提取 - 操作
      operationProfit() {
        let that = this;
        if (that.extractMoney == "") {
          that.$message.error(that.$t('strategyNow.enterWithdrawalAmount'));
        } else {
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "profit_operate",
              token: sessionStorage.getItem("token"),
              cid: that.cid,
              number: that.extractMoney
            },
            transformRequest: [(data) => JSON.stringify(data)]
          })
            .then(function (res) {
              if (res.data.status == 200) {
                that.$message({
                  message: that.$t(res.data.msgId),
                  type: "success",
                  duration: 1000
                });
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
          $(".show2Box").fadeOut(50);
        }
      },
      //追加超盘 - 显示
      showAdd(cid) {
        let that = this;
        that.addMoney = "";
        that.cid = cid;
        that.$http({
          url: "/app/Capital/increase_capital_info",
          method: "post",
          data: {
            cid: cid
          },
            transformRequest: [(data) => JSON.stringify(data)]
        })
          .then(function (res) {
            if (res.data.status == 200) {
              that.balance = res.data.data.total;
              that.minAdd = res.data.data.min_increase;
              that.warningIncreaseInfo = res.data.data.warning;
              that.closeIncreaseInfo = res.data.data.close;
              that.warning_line_ratio_increase_info = res.data.data.warning_line_ratio;
              that.close_line_ratio_increase_info = res.data.data.close_line_ratio;
              that.multiple = res.data.data.multiple;
              that.number = res.data.data.number;
              that.bond = res.data.data.bond;
              that.warning_ratio = res.data.data.warning_ratio;
              that.close_ratio = res.data.data.close_ratio;
              that.increase_bond_capital = res.data.data.increase_bond;
              that.cashCapitalInfo = res.data.data.cash;

              that.afterCashCapitalInfo = that.cashCapitalInfo;
              that.balanceAfter = that.balance;
              that.warningIncreaseInfoAfter = that.warningIncreaseInfo;
              that.closeIncreaseInfoAfter = that.closeIncreaseInfo;
              that.warning_line_ratio_increase_info_after = that.warning_line_ratio_increase_info.replace(/[^0-9.-]/g, '');
              that.close_line_ratio_increase_info_after = that.close_line_ratio_increase_info.replace(/[^0-9.-]/g, '');

              $(".show3Box").fadeIn(50);
            } else {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      },
      //追加超盘 - 隐藏
      hiddenAdd() {
        $(".show3Box").fadeOut(50);
      },
      //追加超盘 - 操作
      operationAdd() {
        let that = this;
        if (that.addMoney == "") {
          that.$message.error(that.$t('increaseInfo.enterAdditionalAmountMsg'));
        } else {
          that.$http({
            url: "/app/Capital/increase_capital_operate",
            method: "post",
            data: {
              
              cid: that.cid,
              number: that.addMoney
            },
            transformRequest: [(data) => JSON.stringify(data)]
          })
            .then(function (res) {
              if (res.data.status == 200) {
                that.$message({
                  message: that.$t(res.data.msgId),
                  type: "success",
                  duration: 1000
                });
                that.getNowData();
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
          $(".show3Box").fadeOut(50);
        }
      },
      //追加履约金 - 显示
      showBondAdd(cid) {
        let that = this;
        that.addBondMoney = "";
        that.cid = cid;
        that.$http({
          url: "/app/Capital/increase_bond_info",
          method: "post",
          data: {
           
            id: cid
          },
            transformRequest: [(data) => JSON.stringify(data)]
        })
          .then(function (res) {
            if (res.data.status == 200) {
              that.balance = res.data.data.total;
              that.minBondAdd = res.data.data.min_bond;
              that.warningIncreaseBondInfo = res.data.data.warning;
              that.closeIncreaseBondInfo = res.data.data.close;
              that.warning_line_ratio_increase_bond_info = res.data.data.warning_line_ratio;
              that.close_line_ratio_increase_bond_info = res.data.data.close_line_ratio;
              that.multiple = res.data.data.multiple;
              that.number = res.data.data.number;
              that.bond = res.data.data.bond;
              that.warning_ratio = res.data.data.warning_ratio;
              that.close_ratio = res.data.data.close_ratio;
              that.increase_bond = res.data.data.increase_bond;
              that.cashBondInfo = res.data.data.cash;

              that.afterCashBondInfo = that.cashBondInfo;
              that.balanceAfter = that.balance;
              that.warning_line_ratio_increase_bond_info_after = that.warning_line_ratio_increase_bond_info.replace(/[^0-9.-]/g, '');
              that.close_line_ratio_increase_bond_info_after = that.close_line_ratio_increase_bond_info.replace(/[^0-9.-]/g, '');

              $(".show4Box").fadeIn(50);
            } else {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      },
      //追加履约金 - 隐藏
      hiddenBondAdd() {
        $(".show4Box").fadeOut(50);
      },
      //追加履约金 - 操作
      operationBondAdd() {
        let that = this;
        if (that.addBondMoney == "") {
          that.$message.error(that.$t('increaseInfo.enterAdditionalAmountMsg'));
        } else {
          that.$http({
            url: "/app/Capital/increase_bond_operate",
            method: "post",
            data: {
              
              cid: that.cid,
              number: that.addBondMoney
            },
            transformRequest: [(data) => JSON.stringify(data)]
          })
            .then(function (res) {
              if (res.data.status == 200) {
                that.$message({
                  message: that.$t(res.data.msgId),
                  type: "success",
                  duration: 1000
                });
                that.getNowData();
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
          $(".show4Box").fadeOut(50);
        }
      },
      //申请结算 - 显示
      showSettlement(cid) {
        $(".show1Box").fadeIn(50);
        this.cid = cid;
      },
      //申请结算 - 隐藏
      hiddenSettlement() {
        $(".show1Box").fadeOut(50);
      },
      //申请结算 - 操作
      operationSettlement() {
        let that = this;
        $(".show1Box").fadeOut(50);
        that.$http({
          url: "/app/Capital/settlement",
          method: "post",
          data: {
            
            cid: that.cid
          },
            transformRequest: [(data) => JSON.stringify(data)]
        })
          .then(function (res) {
            if (res.data.status == 200) {
              that.$message({
                message: that.$t(res.data.msgId),
                type: "success",
                duration: 1000,
                onClose:function () {
                  that.getNowData();
                  that.getHistoryData();
                  document.documentElement.scrollTop = document.body.scrollTop = 0;
                  that.activeName = '2';
                }
              });
              // window.sessionStorage.setItem("accountType", 3);
              // this.$store.state.accountType = 3;
              // that.$router.push({
              //   path: "/myaccount/strategyhistory"
              // });
            } else {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      },
      getHistoryData() {
        let that = this;
        that
          .$http({
            url: "/app/Capital/history_operate",
            method: "post",
            data: {
              
            },
            transformRequest: [(data) => JSON.stringify(data)]
          })
          .then(function (res) {
            if (res.data.status == 200) {
              that.historyList = res.data.data;
            } else {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      },
      //去详情
      goDetails(cid) {
        window.sessionStorage.setItem("cid", cid);
        this.$router.push({
          path: "/myaccount/strategyhistorydetails"
        });
      },
      //去申请配资子账户
      goApply() {
        this.$router.push({
          path: '/operate/operateday'
        })
      },
      //获取对账单
      getCapitalData(cid, information) {
        let that = this;
        that
          .$http({
            url: "/app/CapitalLog/capital_log",
            method: "post",
            data: {
              
              'capital': cid
            },
            transformRequest: [(data) => JSON.stringify(data)]
          }).then(res => {
          if (res.data.status == 200) {
            let capitalData = res.data.data;
            switch (information) {
              case 'all':
                that.capitalState = true;
                that.capitalData = capitalData;
                break;
              case 'ensure':
                that.moneyState = true;
                let ensure = [];
                for (let i = 0, len = capitalData.length; i < len; i++) {
                  if (capitalData[i].typeState === 2 || capitalData[i].typeState === 14) {
                    ensure.push(capitalData[i]);
                  }
                }
                that.moneyData = ensure;
                break;
              case 'money':
                that.moneyState = true;
                let money = [];
                for (let i = 0, len = capitalData.length; i < len; i++) {
                  if (capitalData[i].typeState === 1 || capitalData[i].typeState === 2 || capitalData[i].typeState === 13 || capitalData[i].typeState === 14) {
                    money.push(capitalData[i]);
                  }
                }
                that.moneyData = money;
                break;

            }

          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
      },

      //获取持仓
      getHoldData(cid){
        let that = this;
        that
          .$http({
            url: "/app/Depot/depot_stock",
            method: "post",
            data: {
              
              'cid': cid
            },
            transformRequest: [(data) => JSON.stringify(data)]
          })  .then(res => {
          if (res.data.status == 200) {
            that.holdState = true;
            var dataArr = res.data.data;
            var shortArr = [];
            if (dataArr.length != 0) {
              $.each(dataArr, function(index, item) {
                shortArr.push(item.short);
              });
              that.getNewPrice(shortArr, dataArr);
              /*clearInterval(window.timer1);
              window.timer1 = setInterval(function() {
                that.getNewPrice(shortArr, dataArr);
              }, 1000);*/
            }else{
              that.holdData = dataArr;
            }
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
      },
      //请求当前价 计算 盈亏  盈亏比例
      getNewPrice(shortArr, dataArr) {
        let that = this;
        $.ajax({
          url: "https://qt.gtimg.cn/q=" + shortArr.toString(),
          type: "GET",
          dataType: "script",
          cache: true,
          success: function() {
            var i, elements;
            for (i = 0; i < shortArr.length; i++) {
              var elements = eval("v_" + shortArr[i]).split("~");
              dataArr[i]["newPrice"] = elements[3]; //当前价
              var newPrice = parseFloat(elements[3]); //当前价
              var number = parseFloat(dataArr[i].number); //持有股数
              var costPrice = parseFloat(dataArr[i].price); //成本价
              var profitPrice = Number((newPrice - costPrice).toFixed(2)); //盈亏金额
              var priceRatio = ((newPrice - costPrice) / costPrice) * 100; //盈亏比例
              var market = (newPrice * number).toFixed(2); //当前市值
              priceRatio = priceRatio.toFixed(2);
              dataArr[i]["profitPrice"] = profitPrice;
              dataArr[i]["priceRatio"] = priceRatio;
              dataArr[i]["market"] = market;
            }
            that.holdData = dataArr;
          }
        });
      },

      openDetailed(cid){
        let that = this;
        that.$router.push('/stockmarket/rise');
      }
    }
  };
</script>
<style scoped>
  @import url("./../assets/css/entrust.css");

  .font12 {
    font-size: 10px;
  }
  .show_content_strategynow_colored{
      background-color: #faf3e9;
      padding: 10px;
      font-size: 15px;
  }
  .show_content_strategynow{
      padding: 10px;
      font-size: 15px;
  }
  .strategynow_matching_amt{
      border: 1px solid #ccc !important; 
      width:500px !important;
      height:50px !important;
      padding-left: 25px !important;
      margin-top: 15px !important;
      margin-bottom: 15px !important;
  }
  .percentageColor{
      color:red;
  }

  
.mainButtons {
  color: var(--baseColor) !important;
  background-color: #ffffff !important;
  border-color: var(--baseColor) !important;
}

.mainButtons:hover {
  color: var(--baseColor) !important;
  background-color: #ffffff !important;
  border-color: var(--baseColor) !important;
}

/* Apply styles to the active button */
.activeButton {
  color: #ffffff !important;
  background-color: var(--baseColor) !important;
  border-color: var(--baseColor) !important;
}
.activeButton:hover {
  color: #ffffff !important;
  background-color: var(--baseColor) !important;
  border-color: var(--baseColor) !important;
}

.sideGrey-btn {
  background-color: #909399;
  border-radius: 7px;
  padding: 4px 15px;
  color: #ffffff;
  font-size: 14px;
  width: fit-content;
  text-align: end;
}
.center-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10vh;
  font-size: 12px;
	color:gray;
}
.capitalInfo {
  /* height: 60px; */
  margin: 10px 0px;
}
.capitaldetail {
  font-size: 14px;
  background: #ffffff;
  padding: 30px;
  margin-top: -20px;
  margin-bottom: -20px;
  border-radius: 15px;
}

.capitaldetail1 {
  margin-left: -19px;
  margin-right: 8px;
}

.capitaldetail3 {
  margin-right: -19px;
  margin-left: 8px;
}

.capitaldetail .balance {
  font-size: 30px;
  color: #EE5C35;
  margin-top: 10px;
}

.capitaldetail h4 {
  font-weight: normal;
  color: #101010;
  font-size: 16px;
}

.content-flex {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.box-card1 {
  border-radius: 8px; 
  /* height: 20vh; */
  background-color: #F4F4F8; 
  box-shadow: none; 
}

</style>
<style>
#stratergyNowtabs .el-tabs__active-bar {
  display: none;
  background-color: var(--baseColor);
}
#stratergyNowtabs .el-tabs__item.is-active {
  color: var(--baseColor);
}
#stratergyNowtabs .el-tabs__item:hover {
  color: var(--baseColor) !important;
}

#stratergyNowtabs .el-tabs__item.is-active:after {
  height: 6px;
  display: block;
  width: auto;
  background: var(--baseColor);
  content: "";
  border-radius: 5px;
  width: 45px;
  display: block;
  margin: 0 auto;
  top: -6px;
  position: relative;
}
</style>





// WEBPACK FOOTER //
// src/components/strategynow.vue